import { Api } from "../../api";

export const fetchSections = (reset = false) => {
  return async (dispatch) => {
    const response = await Api.server.getSections(reset);
    dispatch({ type: "FETCH_SECTIONS", payload: response });
  };
};
